module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara Scott-Goodman, Kate Mathis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Barbara Scott-Goodman is the author of "), _c('I', [_vm._v("The Ski Country Cookbook")]), _vm._v(" among others. She lives in New York City."), _c('br'), _c('br'), _vm._v("Kate Mathis is a commercial photographer based in New York.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zdlaZH/tc-custom/9781452107684.jpg?1705231662873",
      "alt": "This image is the cover for the book Wine Bites"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wine Bites\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Serve the perfectly paired snacks or small plates at your next celebration with this cookbook featuring more than seventy-five simple, scrumptious recipes.")]), _c('br'), _c('br'), _c('i', [_vm._v("Wine Bites")]), _vm._v(" is an inspiring cookbook for those who entertain casually and frequently. More than seventy-five recipes for simple, tasty snacks include suggestions for an accessible wine to pair with each, while vivid color photographs demonstrate how easy these delectable dishes are to prepare. Step-by-step instructions for putting together a first-class cheese plate, creating a generous antipasti platter, or transforming pantry staples into hors d’oeuvres make this an indispensable resource for elevated entertaining.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0